<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Tài khoản</h4>
          </template>
          <template v-slot:body>
            <b-button variant="primary" class="mb-4 mt-2 mr-2">
              <i class="las la-list"/> DS Tài khoản
            </b-button>
            <b-button variant="secondary" class="mb-4 mt-2 mr-2" @click="$router.push({ name: 'manage.account_config' })">
              <i class="las la-cogs"/> Thiết lập
            </b-button>
            <b-button variant="secondary" class="mb-4 mt-2" v-b-modal.account-creator-modal>
              <i class="las la-plus"/> Tạo tài khoản
            </b-button>
            <tab-nav :tabs="true" id="myTab-1">
                <tab-nav-items v-for="(network, index) in networks" :key="network.id" :active="index == 0 ? true : false" :id="`network-${network.id}`" :ariaControls="`home-${network.id}`" role="tab" :ariaSelected="index == 0 ? true : false" :title="network.name" @clicked="changeNetworkChoose(network.id)"/>
            </tab-nav>
            <hr>
            <tab-content id="myTabContent">
              <tab-content-item :active="true" aria-labelled-by="home-tab">
                <div class="table-responsive">
                  <b-table
                    id="account-list-table"
                    ref="accountListTableRef"
                    :items="accountList"
                    :fields="accountFields"
                    :striped="false"
                    :outlined="true"
                    :small="true"
                    :hover="true"
                    :busy="isBusy"
                    :primary-key="'id'"
                    class="table-striped table-bordered"
                    role="grid"
                  >
                    <template v-slot:cell(username)="data">
                      <span v-html="data.item.space"/>
                      <span v-if="data.item.mayHaveChildren">
                        <i v-show="!data.item.toggle" class="las la-caret-square-right" @click="fetchChildren(data.index, data.item.id)"/>
                        <i v-show="data.item.toggle" class="las la-caret-square-down" @click="recursiveCloseSquare(data.item.id, false)"/>
                      </span>
                      <span v-else>
                        <i class="las la-square-o"/>
                      </span>
                      {{data.item.username}}
                    </template>
                    <template v-slot:cell(status)="data">
                      <div v-show="data.item.level === 1 && data.item.parent_id === '0'">
                        <b-badge v-if="data.item.status === '0'" variant="warning">Chờ kiểm tra</b-badge>
                        <b-badge v-if="data.item.status === '-1'" variant="danger">Tạm khóa</b-badge>
                      </div>
                    </template>
                    <template v-slot:cell(attach_formular)="data">
                      <div class="flex align-items-center list-user-action">
                        <a
                          class="iq-bg-primary"
                          data-toggle="tooltip"
                          data-placement="top"
                          v-b-modal.attach-link-modal
                          @click="editObject = data.item"
                        >
                          <i class="las la-plus-circle text-green"/>
                        </a>
                      </div>
                    </template>
                    <template v-slot:cell(edit)="data">
                      <div class="flex align-items-center list-user-action">
                        <a
                          class="iq-bg-primary"
                          data-toggle="tooltip"
                          data-placement="top"
                          title
                          data-original-title="Xem chi tiết"
                          v-show="data.item.level === 1" v-b-modal.account-editor-modal @click="editObject = data.item"
                        >
                          <i class="las la-pen-alt"></i>
                        </a>
                      </div>
                    </template>
                    <template v-slot:cell(delete)="data">
                      <div class="flex align-items-center list-user-action">
                        <a
                          class="iq-bg-primary"
                          data-toggle="tooltip"
                          data-placement="top"
                          title
                          data-original-title="Xem chi tiết"
                          @click="removeAccount(data.item.id, data.item.username)"
                        >
                          <i class="las la-trash-alt text-red"></i>
                        </a>
                      </div>
                    </template>
                    <template v-slot:cell(action)="data">
                      <div class="flex align-items-center list-user-action">
                        <a
                          class="iq-bg-primary"
                          data-toggle="tooltip"
                          data-placement="top"
                          title
                          data-original-title="Xem chi tiết"
                          @click="removeAccount(data.item.id)"
                        >
                          <i class="las la-trash-alt text-red"></i>
                        </a>
                      </div>
                    </template>
                  </b-table>
                </div>
              </tab-content-item>
            </tab-content>
            <account-create-modal modal-id="account-creator-modal" :network-id="selectedNetwork" v-on:created-account="changeNetworkChoose(selectedNetwork)"/>
            <account-editor-modal modal-id="account-editor-modal" :object-edit="editObject" v-on:updated-account="changeNetworkChoose(selectedNetwork)"/>

            <b-modal id="attach-link-modal" title="Gán công thức" ok-title="Xác nhận" cancel-title="Đóng" size="lg">
              <template #modal-header>
                <h4>Gán công thức</h4>
              </template>
              <template #default>
                <link-attach :input-account-id="editObject.id" :network-id="selectedNetwork"/>
              </template>
              <template #modal-footer>
                <b-button variant="default" @click="$bvModal.hide('attach-link-modal')">Đóng</b-button>
              </template>
            </b-modal>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import _ from 'lodash'
import { findash } from '../../config/pluginInit'
import { mapActions, mapGetters } from 'vuex'
import AccountCreateModal from '../../components/application/account/AccountCreateModal'
import AccountEditorModal from '../../components/application/account/AccountEditorModal'
import { skeletorData, skeletorDataParent } from '@/utils'
import api from '../../store/api'
import LinkAttach from '../../components/application/link/LinkAttach'

export default {
  name: 'AccountList',
  components: {
    LinkAttach,
    AccountCreateModal,
    AccountEditorModal
  },
  watch: {
    networks: function (newVal, oldVal) {
      // first time load
      if (oldVal.length === 0 && this.networks) {
        this.changeNetworkChoose(this.networks[0].id)
      }
    }
  },
  mounted () {
    findash.index()

    if (this.networks[0]) { this.changeNetworkChoose(this.networks[0].id) }
  },
  data () {
    return {
      selectedNetwork: null,
      accountFields: [
        {
          key: 'username',
          label: 'Tên tài khoản'
        },
        {
          key: 'status',
          label: 'Trạng thái',
          class: 'text-center'
        },
        {
          key: 'attach_formular',
          label: 'Gán C/Y',
          class: 'text-center',
          thStyle: { width: '10%' }
        },
        {
          key: 'edit',
          label: 'Sửa',
          class: 'text-center',
          thStyle: { width: '5%' }
        },
        {
          key: 'delete',
          label: 'Xóa',
          class: 'text-center',
          thStyle: { width: '5%' }
        }
      ],
      accountList: [],
      isBusy: false,
      editObject: {}
    }
  },
  computed: {
    ...mapGetters({
      'networks': 'Network/listState'
    })
  },
  methods: {
    async changeNetworkChoose (networkId) {
      this.selectedNetwork = networkId

      this.isBusy = true

      let response = await this.loadListByNetwork({ 'network_id': this.selectedNetwork })

      this.accountList = skeletorData(response, { mayHaveChildren: true })

      this.isBusy = false
    },
    createCustomer () {

    },
    ...mapActions({
      'loadListByNetwork': 'Account/loadListByNetwork',
      'loadByParent': 'Account/loadByParent'
    }),
    async fetchChildren (index, parentId) {
      this.isBusy = true
      let childMembers = await this.loadByParent(parentId)

      if (childMembers === false) {
        this.accountList[index].mayHaveChildren = false
      } else {
        let that = this
        let currentIndex = index + 1 // after the current index
        let currentLevel = this.accountList[index].level

        skeletorDataParent(childMembers, this.accountList[index].id, currentLevel, { mayHaveChildren: true })

        _.each(childMembers, (e) => {
          // must use shadow copy splice if want to change data
          that.accountList.splice(currentIndex, 0, e) // insert into array at position
          currentIndex++
        })

        this.accountList[index].toggle = true
      }
      this.isBusy = false
    },
    recursiveCloseSquare (id, isChild) {
      let that = this
      let childrenClose = _.filter(this.accountList, (e) => {
        return e.parentId === id
      })
      _.each(childrenClose, (e) => {
        that.recursiveCloseSquare(e.id, true)
      })

      let index = _.findIndex(this.accountList, (e) => e.id === id)

      this.accountList[index].toggle = false

      // only use with shallow copy method like splice only
      if (isChild) {
        this.accountList.splice(index, 1)
      }
    },
    removeAccount (accountId, username) {
      this.$swal({
        title: username,
        text: 'Bạn chắc chắn xóa tài khoản này ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        if (result.isConfirmed) {
          api.account.delete(accountId).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })
            // load list
            this.changeNetworkChoose(this.selectedNetwork)
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        } else if (result.isDenied) {

        }
      })
    }
  }
}
</script>
